module.exports = __webpack_public_path__ + "static/media/mister_missis_smith.839cbd66.wav";